import { nonEmptyArray, option } from 'fp-ts';
import { constNull, pipe } from 'fp-ts/function';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { SpacingSmallTop } from '@mews-commander/ui';
import { useDashboardWidgets } from '@mews-commander/dashboard/widgets';
import { useMarketplaceWidgets } from '../../../marketplace';
import { useDashboardDataSecurityWidgets } from '../../../dashboardDataSecurityWidgets';
import { useDashboardAtomizeCampaignWidgets } from '../../../dashboardAtomizeCampaignWidgets';
import { getRandomItemByWeight, ItemWithWeight } from './utils';

interface ComponentItemWithWeight extends ItemWithWeight {
    component: React.ReactElement;
}

const getRandomWidget = (widgetItems: Array<ComponentItemWithWeight>) =>
    pipe(
        widgetItems,
        nonEmptyArray.fromArray,
        option.fold(constNull, (itemsWithWeight) => getRandomItemByWeight(itemsWithWeight).component)
    );

export const CommonWidgetsContainer = () => {
    const marketplaceOnlyDataSecurityWidgetsEnabled = useFeatureFlag(
        FeatureFlag.marketplaceOnlyDataSecurityWidgetsEnabled
    );
    const isAtomizeCampaignEnabled = useFeatureFlag(FeatureFlag.displayDashboardTilesForAtomizeCampaign);

    const dashboardWidgets = useDashboardWidgets();
    const marketplaceWidgets = useMarketplaceWidgets();
    const dataSecurityWidgets = useDashboardDataSecurityWidgets();
    const atomizeCampaignWidgets = useDashboardAtomizeCampaignWidgets();

    const widgets = [
        ...dataSecurityWidgets,
        ...(!marketplaceOnlyDataSecurityWidgetsEnabled ? [...dashboardWidgets, ...marketplaceWidgets] : []),
        ...(isAtomizeCampaignEnabled ? atomizeCampaignWidgets : []),
    ];

    return <SpacingSmallTop>{getRandomWidget(widgets)}</SpacingSmallTop>;
};
